import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { colors } from 'Themes/Colors'

const useStyles = makeStyles((_: Theme) =>
  createStyles({
    button: {
      color: colors.red,
      border: `2px solid ${colors.red}`,
    },
    bold: {
      fontWeight: 600,
    },
    closeButton: {
      alignSelf: 'flex-end',
      width: 50,
      marginRight: 10,
      marginTop: 10,
    },
    content: {
      textAlign: 'center',
    },
  })
)

export default useStyles
